import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import {
  BREEDER_CENTER_PATH,
  HELP_PATH,
  MISSION_PATH,
  STANDARDS_PATH,
  HEALTH_TESTING_GUIDE_PATH,
  LEARNING_CENTER_PATH,
  JOINING_FAQS_PATH,
  BREEDER_DASHBOARD_ROOT
} from 'dpl/shared/constants/urls';
import { SIGNUP_FORM_TYPES } from 'dpl/shared/constants/shared';
import { pushParams } from 'dpl/actions/query_params';
import withMobileMenu from 'dpl/decorators/withMobileMenu';
import withCurrentUser from 'dpl/decorators/withCurrentUser';

import MobileNavigationMenu from '../components/MobileNavigationMenu';

const COMMON_LINKS = [
  {
    title: 'FAQs',
    href: JOINING_FAQS_PATH
  },
  {
    title: 'About Us and Our Mission',
    href: MISSION_PATH
  },
  {
    title: 'Our Standards',
    href: STANDARDS_PATH
  },
  {
    title: 'Learning Center',
    href: LEARNING_CENTER_PATH
  },
  {
    title: 'Health Testing Levels',
    href: HEALTH_TESTING_GUIDE_PATH
  },
  {
    title: 'Good Breeder Center',
    href: BREEDER_CENTER_PATH
  },
  {
    title: 'Contact Us',
    href: HELP_PATH
  }
];

function MobileNavigationMenuContainer(props) {
  const LOGGED_IN_LINKS = [
    { title: 'Sign Up', href: BREEDER_DASHBOARD_ROOT }
  ].concat(COMMON_LINKS);
  const LOGGED_OUT_LINKS = [
    {
      title: 'Sign Up',
      onClick: () =>
        props.pushParams(
          { direct_signup: SIGNUP_FORM_TYPES.BREEDER_SIGNUP },
          { hash: true }
        )
    }
  ].concat(COMMON_LINKS);

  return (
    <MobileNavigationMenu
      links={props.isLoggedIn ? LOGGED_IN_LINKS : LOGGED_OUT_LINKS}
      {...props}
    />
  );
}

MobileNavigationMenuContainer.propTypes = {
  pushParams: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired
};

export default compose(
  withCurrentUser,
  withMobileMenu,
  connect(null, { pushParams })
)(MobileNavigationMenuContainer);
